import classes from 'components/common/lottieAnimation/lottieAnimation.module.scss';
import { DotLottie, DotLottieReact } from '@lottiefiles/dotlottie-react';
import { useEffect, useState } from 'react';

interface Props {
    condition: boolean;
    animationSrc: string;
}
export const LottieAnimation = ({ condition, animationSrc }: Props) => {
    const [show, setShow] = useState<boolean>(false);
    const [dotLottie, setDotLottie] = useState<DotLottie | null>(null);
    const dotLottieRefCallback = (dotLottie: DotLottie | null) => {
        setDotLottie(dotLottie);
    };

    useEffect(() => {
        function onComplete() {
            if (dotLottie) {
                setShow(false);
                dotLottie.setFrame(0);
            }
        }
        if (dotLottie) {
            dotLottie.addEventListener('complete', onComplete);
            if (condition) {
                setShow(true);
                dotLottie.play();
            }
        }
        return () => {
            dotLottie?.removeEventListener('complete', onComplete);
        };
    }, [condition, dotLottie]);

    return (
        <div className={`${classes.animationContainer} ${show ? classes.show : ''}`}>
            <DotLottieReact
                src={animationSrc}
                className={classes.animation}
                dotLottieRefCallback={dotLottieRefCallback}
                renderConfig={{
                    autoResize: true,
                }}
            />
        </div>
    );
};
